import { Grid } from '@mui/material'
import React, { useMemo } from 'react'

// Common Components
import TableTemplate, { Column } from '../../Common/Table/TableTemplate'

// Redux
import { useAppSelector } from '../../../redux/store'

// Task Components
import TaskBadge from './TaskTableComponents/TaskBadge'
import TaskDueDateFormat from './TaskTableComponents/TaskDueDateFormat'
import TaskTitle from './TaskTableComponents/TaskTitle'
import TaskActions from './TaskActions/TaskActions'
import { Task } from '../../../redux/task/types'
import UpdateTaskStatus from './TaskTableComponents/UpdateTaskStatus'
import { selectLoadingFetchAssignedTask } from '../../../redux/task/selector'

interface TaskTableProps {
  data: Task[]
  refreshTable: boolean
}

const TaskTable: React.FC<TaskTableProps> = ({ data, refreshTable }) => {
  const loading = useAppSelector(selectLoadingFetchAssignedTask)
  const error = useAppSelector(selectLoadingFetchAssignedTask)
  const state = { loading, error }

  const { userRole } = useAppSelector((state) => state.auth)
  const isAdmin = userRole === 'admin'

  const columns = useMemo<Column[]>(
    () => [
      {
        field: 'title',
        headerName: 'TITLE',
        bodyAlignment: 'center',
        sortable: true,
        width: '20%',
        renderFormat: (title: string) => <TaskTitle value={title} />,
      },
      {
        field: 'dueDate',
        headerName: 'DUE DATE',
        bodyAlignment: 'center',
        sortable: true,
        width: '20%',
        renderFormat: (dueDate: string) => <TaskDueDateFormat value={dueDate} />,
      },
      {
        field: 'importance',
        headerName: 'IMPORTANCE',
        bodyAlignment: 'center',
        width: '20%',
        renderFormat: (importance: string) => (
          <TaskBadge value={importance} badgeType='importanceBadge' />
        ),
      },
      {
        field: 'status',
        headerName: 'STATUS',
        bodyAlignment: 'center',
        width: '20%',
        renderCell: (_params: any, row: Task) => {
          return <UpdateTaskStatus task={row} />
        },
      },
      {
        field: 'action',
        headerName: isAdmin ? 'ACTION' : '',
        bodyAlignment: 'center',
        width: isAdmin ? '20%' : '0%',
        renderCell: (_params: any, row: Task) => {
          return <TaskActions taskData={row} />
        },
      },
    ],
    [refreshTable],
  )

  return (
    <Grid>
      <TableTemplate
        columns={columns}
        datas={data}
        state={state}
        refreshTable={refreshTable}
        uniqueField='id'
      />
    </Grid>
  )
}

export default TaskTable
